'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getComponentName = {};

exports.__exports = getComponentName;
